module.exports = __webpack_public_path__ + "img/maritime-internet.db1583c2.jpg";